/**
 * Allowlist guard for URLs that come from scraped review `sourceData`
 * (`postUrl` / `reviewUrl`).
 *
 * Those values originate from Apify/Firecrawl scrapes and LLM normalisation, so
 * they are attacker-influenceable strings. Promoting one straight into an `href`
 * would let a `javascript:` or `data:` value execute on click, so only absolute
 * `http:` / `https:` URLs are allowed through.
 *
 * @returns the URL as a string when it is safe to use as an `href`, otherwise `undefined`.
 */
export const safeExternalUrl = (url?: unknown): string | undefined => {
  if (typeof url !== "string") return undefined;
  const trimmed = url.trim();
  if (!trimmed) return undefined;

  try {
    const parsed = new URL(trimmed);
    if (parsed.protocol !== "http:" && parsed.protocol !== "https:") {
      return undefined;
    }
    return trimmed;
  } catch {
    // Relative or malformed values are never linkable here.
    return undefined;
  }
};
